

















































import Vue from "vue";
import Dot from "@/components/grapher/Dot.vue";
import DotAppearance from "@/models/DotAppearance";

/**
 * Change a dot type's appearance
 */
export default Vue.extend({
  name: "DotAppearanceModal",
  components: {
    Dot,
  },
  props: {
    dotTypeIndex: Number,
  },
  computed: {
    dotAppearance(): DotAppearance {
      return this.$store.getters.getSelectedStuntSheet.dotAppearances[
        this.dotTypeIndex
      ];
    },
  },
});
